export default __webpack_public_path__ + "static/crio-mission-76c4d93354f4224aa2aa4b00376fad1d.webp";